/* eslint-disable react-refresh/only-export-components */
import type {
  CourseHighlight,
  IPublicCourseResponse,
} from "../../../app/features/courses/courses.types";
import CertificateInfo from "./CertificateInfo";
import CourseItemList from "./CourseItemList";
import CourseOverviewLoading from "./CourseOverviewLoading";

type Props = {
  course?: IPublicCourseResponse;
  isLoading?: boolean;
};

export default function CourseOverview({ course, isLoading }: Props) {
  const learningList = getHighlightList(course?.CourseHighlight, "LEARNING");
  const audienceList = getHighlightList(course?.CourseHighlight, "AUDIENCE");
  const includesList = getHighlightList(course?.CourseHighlight, "INCLUDES");

  if (isLoading) {
    return <CourseOverviewLoading />;
  }

  return (
    <div className="space-y-6">
      <div className="md:h-[25rem] h-64 rounded-xl border border-theme-zinc-200">
        <img
          className="object-cover h-full w-full rounded-xl"
          src={course?.bannerUrl || "/images/demo/course/course.png"}
          alt={course?.title}
        />
      </div>

      <CourseItemList
        title="এই কোর্স থেকে তুমি যা যা শিখবে"
        list={learningList}
        classNames={{
          root: "border-theme-error-50",
          header: "bg-theme-red-50 border-theme-error-50",
        }}
      />

      <div className="grid md:grid-cols-2 gap-6">
        <CourseItemList
          title="এই কোর্সটি যাদের জন্য উপযোগী"
          list={audienceList}
          classNames={{
            root: "border-theme-zinc-50",
            header: "bg-theme-sky-25 border-theme-zinc-50",
          }}
        />

        <CourseItemList
          title="এই কোর্সে যা যা থাকছে"
          list={includesList}
          classNames={{
            root: "border-theme-zinc-50",
            header: "bg-theme-sky-25 border-theme-zinc-50",
          }}
        />
      </div>

      {!!course?.isCertificateEnabled && <CertificateInfo />}
    </div>
  );
}

export function getHighlightList(
  list: CourseHighlight[] = [],
  type: CourseHighlight["type"]
) {
  return list
    ?.filter((item) => item.type === type)
    ?.sort((a, b) => a.sortOrder - b.sortOrder)
    ?.map((item) => item.text);
}
